export enum InputTrigger {
    Click = 'click',
    DoubleClick = 'doubleClick',
    Drag = 'drag'
}
